// frontend/src/Components/UI/Sidebar/Sidebar.js
import React from "react";
import { useTranslation } from "react-i18next";
import Logo from '../../common/Logo/Logo';
import './Sidebar.css';

const Sidebar = ({
  isOpen,
  onToggle,
  items = [],          // 🛡️ défaut [] : items absent ne fait plus planter items.map → écran blanc
  currentPath = '',    // 🛡️ défaut '' : currentPath.startsWith(...) sûr même si non résolu
  onNavigate,
  onLogout,
  userName,
  userRole,
}) => {
  const { t } = useTranslation("admin");
  const navItems = (Array.isArray(items) ? items : []).filter((it) => it != null);
  return (
    <div className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
      {/* Bouton de toggle */}
      <div className="sidebar-toggle" onClick={onToggle}>
        <span className="toggle-icon">{isOpen ? '◀' : '▶'}</span>
      </div>

      {/* Contenu de la sidebar */}
      <div className="sidebar-content">
        {/* Logo/Header */}
        <div className="sidebar-header">
          {isOpen ? (
            <div className="sidebar-logo">
              <Logo variant="full" theme="dark" height={56} />
            </div>
          ) : (
            <div className="sidebar-logo-icon">
              <Logo variant="icon" theme="dark" height={42} />
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {navItems.map((item, index) => {
            // Pour /admin (tableau de bord), ne matcher que la route exacte afin
            // d'éviter que tous les sous-menus héritent de l'état actif.
            const isActive = item.path === '/admin'
              ? (currentPath === '/admin' || currentPath === '/admin/')
              : (currentPath === item.path || currentPath.startsWith(item.path + '/'));
            
            return (
              <div
                key={index}
                className={`nav-item ${isActive ? 'active' : ''}`}
                onClick={() => onNavigate(item.path)}
              >
                <span className="nav-icon">{item.icon}</span>
                {isOpen && (
                  <span className="nav-label">{item.label}</span>
                )}
              </div>
            );
          })}
        </nav>

        {/* Footer de la sidebar */}
        <div className="sidebar-footer">
          {isOpen && (
            <div className="user-info">
              <div className="user-avatar">👤</div>
              <div className="user-details">
                <div className="user-name">{userName || 'Administrateur'}</div>
                <div className="user-role">{userRole || 'Administrateur'}</div>
              </div>
            </div>
          )}
          {onLogout && (
            <button
              className={`sidebar-logout-btn${isOpen ? ' expanded' : ''}`}
              onClick={onLogout}
              title={t('nav.logout')}
              aria-label={t('nav.logout')}
            >
              <span className="logout-icon">🚪</span>
              {isOpen && <span className="logout-label">{t('nav.logout')}</span>}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;